import { render, staticRenderFns } from "./CaseManager.vue?vue&type=template&id=2bc7aaed&"
import script from "./CaseManager.vue?vue&type=script&lang=js&"
export * from "./CaseManager.vue?vue&type=script&lang=js&"
import style0 from "./CaseManager.vue?vue&type=style&index=0&id=2bc7aaed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports